import React from "react"
import { useTranslation } from "react-i18next"

const ContractShareModal = ({ isOpen, onClose, onShare, title }) => {
  const { t } = useTranslation()
  const duration = 48 // Fixed duration of 48 hours

  const handleShare = () => {
    onShare(duration)
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose}></div>

      <div className="relative bg-light-default rounded-2xl shadow-xl w-full max-w-lg mx-4 p-6 z-10">
        <div className="flex items-start justify-between mb-4">
          <h3 className="text-xl font-semibold text-dark-default">
            {title || t("shareOptions.title")}
          </h3>
          <button
            className="text-dark-default hover:text-black-t-lighten-1"
            onClick={onClose}
            aria-label="Close"
            type="button"
          >
            ✕
          </button>
        </div>

        <div className="mb-5">
          <div className="text-md font-semibold text-dark-default mb-1">
            {t("shareOptions.linkDurationTitle")}
          </div>
        </div>

        {/* Duration option */}
        <div className="space-y-2 mb-5">
          <label className="flex items-center justify-between gap-3 p-4 rounded-xl border-2 border-dark-default bg-light-default cursor-pointer transition">
            <div>
              <div className="text-base font-semibold text-dark-default">
                {t("shareOptions.options.2days.label")}
              </div>
              <div className="text-sm text-dark-default">
                {t("shareOptions.options.2days.description")}
              </div>
            </div>
            <div className="w-5 h-5 rounded-full border-2 border-dark-default flex items-center justify-center">
              <div className="w-2.5 h-2.5 rounded-full bg-dark-default"></div>
            </div>
          </label>
        </div>

        {/* Info card */}
        <div className="rounded-xl border border-dark-t-lighten-5 p-4 bg-accent-default text-dark-default mb-5">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-sm font-semibold">
              {t("shareOptions.infoTitle")}
            </span>
          </div>
          <div className="text-sm whitespace-pre-line">
            {t("shareOptions.infoText")}
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            className="px-4 py-2 rounded-lg border border-dark-t-lighten-5 text-dark-default hover:bg-white-t-lighten-6"
            onClick={onClose}
          >
            {t("common.cancel")}
          </button>
          <button
            type="button"
            className="px-5 py-2 rounded-lg text-light-default shadow inline-flex items-center gap-2 bg-dark-default hover:bg-black-t-lighten-1"
            onClick={handleShare}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-4 h-4"
              aria-hidden="true"
            >
              <path d="M16 1a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h7zm0 2H9a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z" />
              <path d="M6 7a1 1 0 0 0-1 1v9a3 3 0 0 0 3 3h7a1 1 0 1 0 0-2H8a1 1 0 0 1-1-1V8a1 1 0 0 0-1-1z" />
            </svg>
            <span>{t("shareOptions.share")}</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default ContractShareModal
